import { Button, Flex } from "antd";
import { useViewerStore } from '../../../../../store/store';

interface DiscardBuildingPopupProps {
    onConfirm: () => void;
}

const DiscardBuildingPopup = ({ onConfirm }: DiscardBuildingPopupProps) => {

    const { sceneViewer } = useViewerStore();
    const confirmDiscard = () => {
        onConfirm();
        sceneViewer.viewerAlert({ show: false });
    }
    const cancel = () => sceneViewer.viewerAlert({ show: false });

    return (
        <>
            {
                (<>

                    <p className="report-text">You have unsaved changes in building/ roofs attributes</p>
                    <p className="report-text">Are you sure you want to discard the changes?</p>

                    <div className={"modal-bottom-action-button-container"}>
                        <Button
                            id={"confirmSiteReportBtn"}
                            type="primary"
                            size="large"
                            className="editor__control--finalize modal-confirm-button"
                            onClick={confirmDiscard}
                        >
                            Discard
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="editor__control--finalize modal-cancel-button"
                            onClick={cancel}
                        >
                            Cancel
                        </Button>
                    </div>
                </>)
            }
        </>
    )
}

export default DiscardBuildingPopup;